import DrugConsumptionTable from "../../DrugConsumptionTable/DrugConsumptionTable"

const DrugCon = () => {
  return (
    <div>
      <DrugConsumptionTable/>
    </div>
  )
}

export default DrugCon
